/**
 * Home Page Component
 * Main landing page component rendering the top-level Hero section,
 * stats overview, and hub navigation cards for the application.
 */

import React from 'react';
import Hero from '../Components/Home/Hero';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      {/* Top Hero and Hub Section Container */}
      <Hero />
    </div>
  );
};

export default Home;
